import { USER_DETAILS } from "../constants"

const userDetails = (data) => {
    return {
        type: USER_DETAILS,
        data: data
    }
}
export default userDetails;